module.exports = __webpack_public_path__ + "static/media/avatar.432f0597.svg";